import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="m8.15 15.743 7.71-7.59L8.15.562l-.97.94c1.74 1.71 4.04 3.98 6.07 5.98H.69v1.34h12.56l-6.07 5.96.97.95v.01Z"
    />
  </Svg>
);
export default SvgComponent;
